import { useMemo } from 'react'

export const useDeviceSupport = (driver) => {
  return useMemo(() => {
    return (
      (driver === 'bluetooth' && 'bluetooth' in window.navigator) ||
      (driver === 'usb' && 'usb' in window.navigator) ||
      (driver === 'serial' && 'serial' in window.navigator)
    )
  }, [driver])
}
